import Navbar from '../components/navbar';
import Pagebanner from '../components/pageBanner';
import { AboutIsc, PropertyExchange, Propertyavailableexchange, KnowMoreIsc} from '../components/index';
import React from 'react';
import '../css/main.css';

const HomePage = () =>{
    return(
        <>
        <Navbar />
        <Pagebanner />
        <AboutIsc />
        <PropertyExchange />
        <Propertyavailableexchange />
        <KnowMoreIsc />


        </>
    )
}
export default HomePage;